// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1l7V3","errorLogs":"styles_errorLogs__2V6T9"};